import { createRouter } from "@tanstack/react-router";

import { routeTree } from "../routeTree.gen";
import {
  type AuthProjection,
  createAnonymousAuthProjection,
  subscribeRouterToAuthInvalidation,
} from "./auth";

export function createRouterWithAuth(
  auth: AuthProjection,
  history?: Parameters<typeof createRouter>[0]["history"],
) {
  const router = createRouter({
    routeTree,
    context: { auth },
    ...(history ? { history } : {}),
  });
  subscribeRouterToAuthInvalidation(auth, () => router.invalidate());
  return router;
}

export const router = createRouterWithAuth(createAnonymousAuthProjection());

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
